import { combineReducers } from 'redux';
import activeCustomerReducer from './ActiveCustomer/store/activeCustomerReducer';

export const reducers = combineReducers({
    activeCustomer: activeCustomerReducer
});